import { config } from '@/pageConfig/claims/fr/en';
import { ClaimsPageTemplate } from '@/pageTemplate/ClaimsPageTemplate';

export default function ClaimsPage() {
  return <ClaimsPageTemplate config={config} />;
}
